import { Record } from 'immutable';
import { makeAppKey } from './AppKey';
export const makeMarketplaceApp = Record({
  key: makeAppKey(''),
  name: '',
  summary: undefined,
  tagLine: undefined,
  _embedded: undefined,
  legacy: undefined,
  vendorLinks: undefined,
  programs: undefined
});